import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import Spinner from '../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { getUsers } from '../../User/Store/actions'
import { AppointmentsReport } from '../AppointmentsReport/AppointmentsReport'
import { ExpensesReport } from '../ExpensesReport/ExpensesReport'
import ReportHrTime from '../HRTime'
import { OccupancyRateReport } from '../OccupancyRateReport/OccupancyRateReport'
import { PerformanceOverview } from '../PerformanceReport/PerformanceOverview/PerformanceOverview'
import { ProjectedEarnings } from '../ProjectedEarnings/ProjectedEarnings'
import { ReportDashboard } from '../ReportDashboard'
import SimpleDayReceiptReport from '../SimpleDayReceiptReport'
import TopCustomerReport from '../TopCustomerReport'

export const Bootstrap = () => {
  const dispatch = useAppDispatch()

  const { users } = useAppSelector(state => {
    return {
      users: state.users.list,
    }
  })

  useEffect(() => {
    dispatch(getUsers())
  }, [])

  if (typeof users === 'undefined' || users === null) {
    return <Spinner />
  }

  return (
    <Switch>
      <Route path="/report/dashboard" component={ReportDashboard} />
      <Route
        path="/report/simple-day-receipts"
        component={SimpleDayReceiptReport}
      />
      <Route path="/report/top-customers" component={TopCustomerReport} />
      <Route
        path="/report/person-performance"
        component={PerformanceOverview}
      />
      <Route path="/report/hr-time" component={ReportHrTime} />
      <Route path="/report/expenses" component={ExpensesReport} />
      <Route path="/report/occupancy-rate" component={OccupancyRateReport} />
      <Route path="/report/appointments" component={AppointmentsReport} />
      <Route path="/report/projected-earnings" component={ProjectedEarnings} />
    </Switch>
  )
}
